module.exports = __webpack_public_path__ + "static/media/subsc-background.70b20a9d.png";